import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, cn } from '@mf-tools/domains-ui';
import { Building2, Shield, User } from 'lucide-react';
import { Container } from '../components';

export interface WhoForProps {
  className?: string;
}

export function WhoFor({ className }: WhoForProps): React.ReactElement {
  return (
    <section id="who" className={cn('py-14 sm:py-20', className)} aria-labelledby="who-title">
      <Container>
        <div className="space-y-10">
          <div className="max-w-3xl space-y-3">
            <h2 id="who-title" className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
              Built for Seed → Series A teams.
            </h2>
            <ul className="grid gap-2 text-sm text-muted-foreground sm:text-base">
              <li className="flex items-start gap-2">
                <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-primary" aria-hidden="true" />
                U.S. startups, 2–50 employees
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-primary" aria-hidden="true" />
                B2B SaaS / AI
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-primary" aria-hidden="true" />
                Founders who want speed without risk
              </li>
            </ul>
          </div>

          <div className="grid gap-4 md:grid-cols-3">
            <Card className="transition-shadow hover:shadow-sm">
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-base">
                  <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-primary/10 text-primary">
                    <User className="h-4 w-4" aria-hidden="true" />
                  </span>
                  Founder / CEO
                </CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">
                Stay focused on product and GTM with a single place to approve, track, and unblock ops work.
              </CardContent>
            </Card>
            <Card className="transition-shadow hover:shadow-sm">
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-base">
                  <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-primary/10 text-primary">
                    <Building2 className="h-4 w-4" aria-hidden="true" />
                  </span>
                  COO / Ops lead
                </CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">
                Replace ad-hoc processes with standardized workflows, owners, and an audit trail.
              </CardContent>
            </Card>
            <Card className="transition-shadow hover:shadow-sm">
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-base">
                  <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-primary/10 text-primary">
                    <Shield className="h-4 w-4" aria-hidden="true" />
                  </span>
                  Security-minded teams
                </CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">
                Sell to enterprise with policies, controls, and evidence workflows built in from day one.
              </CardContent>
            </Card>
          </div>
        </div>
      </Container>
    </section>
  );
}

